// Dutch translations for Materiaal Maatjes UI
module.exports = {
  titles: {
    register: 'Account aanvragen',
    step1: 'Regio',
    step2: 'Ik meld me aan namens een:',
    step3: 'Mijn gegevens',
    step4: 'Organisatie gegevens',
    received: 'Aanvraag ontvangen',
    login: 'Inloggen',
    forgotPassword: 'Wachtwoord vergeten',
    resetPassword: 'Wachtwoord instellen',
    categories: 'Categorieën',
  },
  contact: {
    title: 'Heb je een vraag? Of wil je even contact?',
    intro: 'Onze mensen helpen je graag op weg zodat we samen kunnen werken aan dit mooie initiatief. Laat je gegevens en je vraag achter en dan nemen wij z.s.m. contact met je op.',
    postcodePlaceholder: 'Jouw postcode * (bijv. 1234AB)',
    namePlaceholder: 'Je naam *',
    messagePlaceholder: 'Jouw bericht / vraag ... *',
    privacyText: 'Ik geef toestemming om mijn gegevens te gebruiken voor het gevraagde contact en ga akkoord met het privacybeleid. *',
    gender: {
      placeholder: 'Ik ben een (man / vrouw) *',
      man: 'man',
      woman: 'vrouw'
    },
    successTitle: 'Bedankt voor uw bericht!',
    successBody: 'Als uw bericht een reactie van ons vergt dan hoort u binnen enkele werkdagen van ons.'
  },
  regionMaterials: {
    title: 'Regio Materialen',
    searchPlaceholder: 'Zoek in materialen…',
    filter: {
      providerLabel: 'Aanbieder:',
      statusLabel: 'Status:',
      allCompanies: 'Alle bedrijven',
      allProviders: 'Alle aanbieders',
      allStatuses: 'Alle statussen',
      clear: 'Wis',
    },
    columns: {
      material: 'Titel',
      status: 'Status',
      waarde: 'Waarde',
      author: 'Aanbieder',
      date: 'Datum',
      actions: 'Details',
    },
    status: {
      publish: 'Actief',
      pending: 'Te beoordelen',
      completed: 'Afgerond',
      draft: 'Inactief / Concept',
      trash: 'Verwijderd'
    },
    actions: {
      details: 'Details',
      export: 'Exporteren (selectie)',
      exportAll: 'Alles exporteren'
    },
    empty: 'Geen materialen gevonden voor jouw regio(s).',
    modal: {
      title: 'Materiaal details',
      manageStatus: 'Status wijzigen',
      selectAction: 'Kies actie',
      executeAction: 'Uitvoeren',
      deactivate: 'Inactief maken',
      activate: 'Goedkeuren',
      delete: 'Verwijderen',
      deleteConfirm: 'Weet je zeker dat je dit materiaal wilt verwijderen?',
      manageError: 'Actie mislukt',
      reasonLabel: 'Reden (optioneel, wordt gemaild naar de aanbieder):',
      reasonPlaceholder: 'Vul eventueel een reden in waarom dit materiaal inactief wordt gemaakt…',
      deactivateConfirm: 'Weet je zeker dat je dit materiaal inactief wilt maken? Het is dan niet meer zichtbaar voor anderen en de aanbieder ontvangt een e-mail.',
      deactivationReason: 'Reden inactiviteit:',
    }
  },
  myClaims: {
    title: 'Mijn claims',
    searchPlaceholder: 'Zoek in claims…',
    empty: 'Je hebt nog geen claims.',
    columns: {
      photo: 'Foto',
      title: 'Titel',
      claimNumber: 'Claimnr',
      materialId: 'Advertentie ID',
      status: 'Status',
      waarde: 'Waarde',
      date: 'Datum',
      actions: 'Acties'
    },
    sort: {
      newest: 'Nieuwste eerst',
      oldest: 'Oudste eerst',
      titleAZ: 'Titel A-Z',
      titleZA: 'Titel Z-A',
      statusAZ: 'Status A-Z',
      statusZA: 'Status Z-A',
    },
    modal: {
      title: 'Claimdetails',
      waarde: 'Waarde',
      cancelledReasonTitle: 'Reden annulering:',
      tip: 'Tip: Je kunt contact opnemen met de aanbieder om een afhaalmoment af te spreken.'
    }
  },
  productManage: {
    title: 'Mijn materialen',
    notCompanyNotice: 'Alleen bedrijfsaccounts en scholen kunnen materialen beheren.',
    notAuthorizedNotice: 'Je hebt geen rechten om materialen te beheren.',
    overview: 'Overzicht',
    empty: 'Geen materialen gevonden.',
    emptyAction: 'Voeg je eerste materiaal toe.',
    searchPlaceholder: 'Zoek in materialen…',
    dashboard: {
      title: 'Dashboard',
      loading: 'Laden dashboard…',
      welcome: 'Welkom terug op je Materiaal Maatjes dashboard. Hier zie je in één oogopslag de belangrijkste acties.',
      openClaimsBedrijf: 'Er zijn {count} claims die nog moeten worden afgehandeld of afgerond.',
      openClaimsSchool: 'Je hebt {count} lopende claims. Zodra deze zijn goedgekeurd kun je ze ophalen.',
      openClaimsBedrijfTitle: 'Openstaande claims',
      openClaimsSchoolTitle: 'Mijn actieve claims',
      regioTitle: 'Regio Beheer',
      regioDesc: 'Beheer de materialen en claims in jouw regio’s.',
      profileTitle: 'Mijn gegevens',
      profileDesc: 'Houd je contactgegevens en organisatie informatie up-to-date.',
      viewClaims: 'Bekijk claims',
      viewMyClaims: 'Bekijk mijn claims',
      regioOverview: 'Regio overzicht',
      editProfile: 'Profiel wijzigen',
      todoBedrijf: 'Claims die je aandacht nodig hebben',
      todoSchool: 'Lopende claims',
      todoProvider: 'Claims op jouw materialen',
      viewAllClaims: 'Bekijk alle claims',
      viewAllMaterials: 'Bekijk al mijn materialen',
      pendingApprovalsTitle: 'Bedrijven / scholen die nog goedgekeurd dienen te worden',
      pendingMaterialsTitle: 'Te beoordelen materialen',
      inactiveMaterialsTitle: 'Inactieve materialen',
      manageAllRegionMaterials: 'Beheer alle regiomaterialen',
      menu: {
        myAccount: 'Mijn account',
        overview: 'Overzicht',
        myDetails: 'Mijn gegevens',
        changePassword: 'Wachtwoord wijzigen',
        myClaims: 'Mijn Claims',
        myMaterials: 'Mijn materialen',
        addMaterial: 'Materiaal toevoegen',
        regionManagement: 'Regio beheer',
        regionMaterials: 'Regio Materialen',
        regionClaims: 'Regio Claims',
        regionCompanies: 'Regio Bedrijven',
        regionSchools: 'Regio Scholen',
        logout: 'Uitloggen'
      }
    },
    sort: {
      newest: 'Nieuwste eerst',
      oldest: 'Oudste eerst',
      titleAZ: 'Titel A-Z',
      titleZA: 'Titel Z-A',
      statusAZ: 'Status A-Z',
      statusZA: 'Status Z-A',
    },
    filter: {
      all: 'Alles',
      allTypes: 'Alle types',
      offered: 'Aangeboden',
      requested: 'Gevraagd',
      typeLabel: 'Type:',
    },
    columns: {
      photo: 'Foto',
      title: 'Titel',
      type: 'Type',
      adId: 'Advertentie ID',
      status: 'Status',
      date: 'Datum',
      actions: 'Acties'
    },
    table: {
      type: 'Type',
    },
    labels: {
      adId: 'Advertentie ID',
      status: 'Status',
      sections: {
        base: 'Basis',
        properties: 'Eigenschappen',
        categories: 'Categorieën',
        image: 'Afbeeldingen',
      },
      image: {
        newOptional: 'Nieuwe afbeelding (optioneel)',
        chosen: 'Gekozen:',
        recommended: 'Aanbevolen formaat 1200×800px of groter. Max. 4MB.',
        current: 'Huidige afbeelding',
        markedForDeletion: 'Afbeelding wordt verwijderd bij opslaan',
        zoom: 'Vergroten',
        zoomTitle: 'Afbeelding vergroten',
      }
    },
    placeholders: {
      title: 'Titel',
      description: 'Beschrijving',
      valueEUR: 'Waarde (EUR)',
      dimensions: 'Afmetingen',
      weight: 'Gewicht',
      location: 'Plaats',
      noTitle: 'Zonder titel',
    },
    buttons: {
      edit: 'Bewerken',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      save: 'Opslaan',
      saveAndUpload: 'Definitief opslaan en uploaden',
      saving: 'Opslaan…',
      deleteConfirm: 'Definitief verwijderen',
      busy: 'Bezig…',
      deleteImage: 'Bestaande afbeelding verwijderen',
      restoreImage: 'Herstellen',
      addImages: 'Afbeeldingen toevoegen',
    },
    tooltips: {
      editDisabled: 'Geclaimde materialen kunnen niet bewerkt worden.',
      deleteDisabled: 'Geclaimde materialen kunnen niet verwijderd worden.'
    },
    confirm: {
      deleteTitle: 'Materiaal verwijderen',
      deleteText: 'Weet je zeker dat je dit materiaal wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden.'
    },
    status: {
      concept: 'Concept',
      archive: 'Archief',
      claimed: 'Geclaimd',
      active: 'Actief'
    },
    messages: {
      saved: 'Materiaal opgeslagen',
      deleted: 'Materiaal verwijderd',
      loadError: 'Kon materialen niet laden',
      saveError: 'Opslaan mislukt',
      deleteError: 'Verwijderen mislukt'
    }
  },
  regionDeals: {
    title: 'Regio Claims',
    searchPlaceholder: 'Zoek in claims…',
    filter: {
      label: 'Filter:',
      role: {
        all: 'Alle',
        bedrijf: 'Bedrijven',
        school: 'Scholen',
      },
      specific: 'Specifiek:',
      allCompanies: 'Alle bedrijven',
      allSchools: 'Alle scholen',
      clear: 'Wis',
    },
    columns: {
      material: 'Titel',
      claimNumber: 'Claimnr',
      provider: 'Aanbieder',
      claimedBy: 'Geclaimd door',
      status: 'Status',
      waarde: 'Waarde',
      date: 'Datum',
      actions: 'Details',
    },
    empty: 'Geen claims gevonden voor jouw regio(s).',
    modal: {
      title: 'Claim details',
      adId: 'Advertentie ID',
      claimNumber: 'Claimnr',
      status: 'Status',
      waarde: 'Waarde',
      provider: 'Aanbieder',
      claimedBy: 'Geclaimd door',
      date: 'Datum',
      cancelledOn: 'Geannuleerd op',
      reason: 'Reden',
      manageStatus: 'Status wijzigen',
      selectStatus: 'Kies nieuwe status',
      executeAction: 'Uitvoeren',
    },
    status: {
      pending: 'In behandeling',
      rejected: 'Afgewezen',
      completed: 'Afgerond',
      cancelled: 'Geannuleerd',
    },
    actions: {
      details: 'Details',
      export: 'Exporteren (selectie)',
      exportAll: 'Alles exporteren'
    },
    csv: {
      providerEmail: 'Aanbieder Email',
      providerPhone: 'Aanbieder Telefoon',
      providerRegions: 'Aanbieder Regio’s',
      claimerEmail: 'Claimer Email',
      claimerPhone: 'Claimer Telefoon',
      claimerRegions: 'Claimer Regio’s',
    }
  },
  descriptions: {
    registerIntro: 'Vul onderstaand formulier in om een account aan te vragen bij Materiaal Maatjes. Wij behandelen uw aanvraag persoonlijk en maken daarna een account voor u aan. U ontvangt dan een e-mail van ons met daarin de link om in te loggen.',
    step1: 'Wij zijn nog niet actief in alle regio’s. Vul jouw postcode in om te zien of we in jouw regio al actief zijn.',
    step2: 'Bedrijven kunnen materiaal plaatsen. Scholen kunnen materiaal claimen.',
    step3: 'Nodig voor jouw account. Deze gegevens worden niet openbaar gepubliceerd.',
    step4: 'Nodig voor jouw account. De link naar de website is zichtbaar voor ingelogde gebruikers.',
  },
  roles: {
    company: 'Bedrijf',
    school: 'School',
  },
  rolePicker: {
    title: 'Met welke rol wil je inloggen?',
    description: 'Je account heeft meerdere rollen. Kies hieronder hoe je wilt inloggen. Je kunt later altijd wisselen via je account.',
  },
  roleSwitcher: {
    label: 'Rol wisselen',
  },
  placeholders: {
    postcode: 'Jouw postcode *',
    firstName: 'Voornaam *',
    lastName: 'Achternaam *',
    email: 'E-mailadres *',
    emailConfirm: 'E-mailadres bevestigen *',
    phone: 'Telefoonnummer',
    orgNameSchool: 'Schoolnaam *',
    orgNameCompany: 'Bedrijfsnaam *',
    functionName: 'Mijn functie *',
    street: 'Straatnaam *',
    houseNr: 'Huisnummer *',
    orgPostcode: 'Postcode * ',
    city: 'Woonplaats *',
    website: 'Website adres *',
    usernameOrEmail: 'E-mailadres *',
    password: 'Wachtwoord *',
    newPassword: 'Nieuw wachtwoord * (min. 12 tekens)',
    confirmPassword: 'Bevestig wachtwoord *'
  },
  messages: {
    successReceivedTitle: 'Aanvraag ontvangen',
    successRegister: 'Dankjewel voor je aanmelding. Je account wordt beoordeeld door onze regio-coordinator. Je ontvangt een e-mail met logingegevens zodra de beoordeling heeft plaatsgevonden.',
    loginSuccess: 'Succesvol ingelogd.',
    forgotInfo: 'Als dit e-mailadres bij ons bekend is, ontvang je zo een e-mail met verdere instructies.',
    forgotNotFound: 'Er is geen account bekend met dit e-mailadres. Controleer of het e-mailadres juist is of neem contact op met info@materiaalmaatjes.nl.',
    passwordSaved: 'Je wachtwoord is aangepast. Je kunt nu inloggen met je nieuwe wachtwoord.',
    postcodeActive: 'Mooi! Materiaal Maatjes is actief in jouw regio. Ga verder met registreren.',
    postcodeActiveCompany: 'Materiaal Maatjes is nog niet actief in jouw regio, maar als bedrijf kun je wel alvast een account aanvragen.',
    postcodeInvalid: 'Postcode lijkt onjuist.',
    regionsNotConfigured: 'Regio-validatie is nog niet geconfigureerd. Neem contact op met de beheerder.',
    regionInactive: 'Helaas, we zijn nog niet actief in jouw regio.',
    interestSuccess: 'Bedankt! We hebben je gegevens ontvangen en nemen contact met je op.',
    emailInvalid: 'Vul een geldig e-mailadres in.',
    emailsNoMatch: 'De e-mailadressen komen niet overeen.',
    postcodeInvalidFormat: 'Vul een geldige postcode in (bijv. 1234AB).',
    postcodeValid: 'Postcode is geldig.',
    verificationDisabled: 'Verificatie uitgeschakeld',
    turnstileError: 'Verificatie mislukt. Probeer opnieuw.',
    turnstileExpired: 'Verificatie verlopen. Bevestig a.u.b. opnieuw.',
    turnstileLoadFailed: 'Kon Cloudflare Turnstile niet laden.',
    submitFailed: 'Verzenden mislukt. Probeer het later opnieuw.',
    genericError: 'Er ging iets mis. Probeer later opnieuw.',
    loginFailed: 'Inloggen mislukt. Controleer je gegevens.',
    loading: 'Laden…',
    errorFetchingCategories: 'Fout bij ophalen categorieën',
    capsLockOn: 'Caps Lock is aan'
  },
  myDeals: {
    title: 'Mijn claims',
    searchPlaceholder: 'Zoek in claims…',
    empty: 'Nog geen claims.',
    columns: {
      claimDate: 'Claim datum',
      claimStatus: 'Claim status',
      waarde: 'Waarde',
    },
    modal: {
      title: 'Claim details',
      claimDate: 'Claim datum',
      waarde: 'Waarde',
      updateStatus: 'Status bijwerken',
      claimAdmin: 'Claim beheer',
      releaseReasonTitle: 'Reden vrijgeven',
      releaseReasonPlaceholder: 'Beschrijf kort waarom je de claim vrijgeeft (verplicht)',
      release: 'Vrijgeven',
      notClaimed: 'Dit materiaal is momenteel niet geclaimd.',
      releasedWithReason: 'Vrijgegeven met reden: '
    },
    actions: {
      export: 'Exporteren (selectie)',
      exportAll: 'Alles exporteren'
    }
  },
  regionUsers: {
    title: {
      companies: 'Regio Bedrijven',
      schools: 'Regio Scholen',
    },
    searchCompanies: 'Zoek in bedrijven…',
    searchSchools: 'Zoek in scholen…',
    empty: 'Geen resultaten gevonden voor jouw regio(s).',
    columns: {
      name: 'Naam',
      email: 'E‑mail',
      postcode: 'Postcode',
      city: 'Plaats',
      approved: 'Status',
      actions: 'Details'
    },
    status: {
      approved: 'Goedgekeurd',
      pending: 'In afwachting',
      deactivated: 'Gedeactiveerd',
      rejected: 'Geweigerd'
    },
    modal: {
      titleCompany: 'Bedrijf details',
      titleSchool: 'School details'
    },
    labels: {
      role: 'Rol',
      functionName: 'Mijn functie',
      status: 'Status',
      name: 'Naam',
      email: 'E‑mail',
      postcode: 'Postcode',
      city: 'Plaats',
      address: 'Adres',
      phone: 'Telefoonnummer',
      website: 'Website',
      regions: 'Regio(’s)',
      coordinatorEmail: 'E-mail coördinator',
      manageRegions: 'Regio management',
      updateRegion: 'Automatisch (op basis van postcode)',
      manualRegion: 'Handmatige regio selectie',
      selectRegion: 'Selecteer een regio…',
      updateRegionInProgress: 'Bezig met bijwerken…',
      updateRegionSuccess: 'Regio succesvol bijgewerkt',
      registeredDate: 'Lid sinds',
      approvedBy: 'Beoordeeld door',
    },
    cta: {
      viewCompanyDeals: 'Bekijk claims van dit bedrijf',
      viewCompanyMaterials: 'Bekijk materialen van dit bedrijf',
      viewSchoolDeals: 'Bekijk claims van deze school'
    },
    approve: {
      action: 'Keur account goed',
      inProgress: 'Bezig met goedkeuren…'
    },
    deactivate: {
      action: 'Account inactief maken',
      inProgress: 'Bezig met deactiveren…',
      reasonLabel: 'Reden (optioneel, wordt gemaild naar gebruiker):',
      reasonPlaceholder: 'Vul eventueel een reden in waarom dit account inactief wordt gemaakt…',
      confirm: 'Weet je zeker dat je dit account inactief wilt maken? De gebruiker kan dan niet meer inloggen en ontvangt een e-mail.'
    },
    reject: {
      action: 'Account weigeren',
      inProgress: 'Bezig met weigeren…',
      reasonLabel: 'Reden voor weigering (wordt gemaild naar aanvrager):',
      reasonPlaceholder: 'Vul een reden in waarom deze aanvraag wordt geweigerd…',
      confirm: 'Weet je zeker dat je deze aanvraag wilt weigeren? De gebruiker wordt hiervan per e-mail op de hoogte gesteld.'
    }
  },
  pagination: {
    itemsPerPage: 'Items per pagina:'
  },
  buttons: {
    downloadPakbon: 'Pakbon downloaden',
    submitRequest: 'Aanvraag versturen',
    login: 'Inloggen',
    logout: 'Uitloggen',
    backToLogin: 'Terug naar inloggen',
    forgotPassword: 'Wachtwoord vergeten?',
    resetPassword: 'Wachtwoord resetten',
    savePassword: 'Wachtwoord opslaan',
    sending: 'Versturen…',
    save: 'Opslaan',
    saving: 'Bezig…',
    close: 'Sluiten',
    closeWindow: 'Venster sluiten',
    clear: 'Wis',
    details: 'Details',
    sendForm: 'Formulier versturen',
  },
  aria: {
    showPassword: 'Toon wachtwoord',
    hidePassword: 'Verberg wachtwoord',
    categoriesRegion: 'Materiaal categorieën',
    scrollLeft: 'Scroll naar links',
    scrollRight: 'Scroll naar rechts',
    modal: 'Dialoogvenster',
    info: 'Toelichting',
    locateMe: 'Locatie bepalen',
    portrait: 'Portret'
  },
  labels: {
    turnstile: 'TURNSTILE',
    photo: 'Foto'
  },
  marketing: {
    pitchTitle: 'In 1 minuut jouw gratis\naccount aanvragen',
    usp1: 'Bedrijven plaatsen restmaterialen online',
    usp2: 'Scholen claimen GRATIS wat ze kunnen gebruiken',
    usp3: 'Samen zorgen we dat niets verloren gaat',
    usp4: 'Goed voor het milieu, goed voor de sector, goed voor de makers van morgen',
    pitchBody: 'Bedrijven en scholen kunnen restmaterialen online plaatsen voor onderlinge uitwisseling.'
  },
  productCreate: {
    title: 'Nieuw materiaal',
    notCompanyNotice: 'Alleen bedrijfsaccounts en scholen kunnen producten toevoegen.',
    notAuthorizedNotice: 'Je hebt geen rechten om materialen toe te voegen.',
    sections: {
      base: 'Basis',
      properties: 'Eigenschappen',
      categories: 'Categorieën',
      image: 'Afbeeldingen'
    },
    labels: {
      title: 'Titel',
      description: 'Beschrijving',
      valueEUR: 'Waarde (EUR)',
      dimensions: 'Afmetingen',
      weight: 'Gewicht',
      pickupLocation: 'Plaats',
      condition: 'Materiaal conditie',
      status: 'Status materiaal'
    },
    tips: {
      title: 'Bijv. 50 stuks vurenhout latten, kopmaat 20x45',
      description: 'Beschrijf het materiaal en relevante details (bijv. staat, hoeveelheid, bijzonderheden).',
      valueEUR: 'Voer hier de financiële waarde in van het materiaal dat je aanbiedt. Dit hoeft niet betaald te worden door de school',
      dimensions: 'Voer hier zo goed als mogelijk de lengte, dikte, omvang, kledingmaat, etc. in.',
      weight: 'Voer hier zo goed als mogelijk het gewicht in.',
      pickupLocation: 'In welke plaats ben je actief en is het materiaal beschikbaar/ gewenst? Exacte locatie voor het afhalen of leveren van het materiaal stem je later af.',
      status: 'Selecteer de fysieke conditie van het materiaal.',
      gallery: 'Voeg meer foto\'s toe om een beter beeld te geven van het materiaal.'
    },
    placeholders: {
      title: 'Bijv. 50 stuks vurenhout latten, kopmaat 20x45',
      description: 'Beschrijving',
      valueEUR: 'Waarde (EUR)',
      dimensions: 'Afmetingen',
      weight: 'Gewicht',
      pickupLocation: 'Plaats',
      condition: '-- Kies conditie --'
    },
    conditionOptions: {
      nieuw: 'Nieuw',
      gebruikt: 'Gebruikt',
      defect: 'Defect'
    },
    statusOptions: {
      publish: 'Actief',
      draft: 'Concept',
      pending: 'In afwachting',
      trash: 'Verwijderd'
    },
    validation: {
      noRights: 'Geen rechten',
      titleRequired: 'Titel is verplicht.',
      selectOneCategory: 'Selecteer minstens één categorie.',
      waardeRequired: 'Waarde is verplicht.',
      imageRequired: 'Minimaal één afbeelding is verplicht.',
      conditionRequired: 'Conditie is verplicht.',
      locationRequired: 'Locatie is verplicht.',
    },
    image: {
      previewAlt: 'Voorbeeld',
      previewTitle: 'Afbeelding preview',
      featuredOptional: 'Hoofdafbeelding (optioneel)',
      galleryTitle: 'Afbeeldingen',
      chosen: 'Gekozen:',
      recommended: 'Aanbevolen formaat 1200×800px of groter. Max. 4MB.'
    },
    messages: {
      createdPrefix: 'Aangemaakt! ID:'
    }
  },
  materials: {
    filters: 'Filteren',
    searchLabel: 'Zoeken',
    searchPlaceholder: 'Zoeken...',
    locationPlaceholder: 'Locatie?',
    km: 'Km',
    sort: 'Sorteer',
    sortNewOld: 'Nieuw - oud',
    sortOldNew: 'Oud - nieuw',
    sortPriceAsc: 'Prijs ↑',
    sortPriceDesc: 'Prijs ↓',
    promoBadge: 'IN 1 MINUUT JOUW GRATIS ACCOUNT AANVRAGEN',
    promoNote: 'Niet ingelogd: dan dit blok als 3e item tonen.',
    tooLate: 'Te laat',
    strength: 'Sterkte',
    packing: 'Verpakking',
    sku: 'SKU',
    stock: 'Voorraad',
    dosage: 'Dosering',
    chooseVariant: 'Kies verpakking',
    addToCart: 'In mandje',
    description: 'Beschrijving',
    noImage: 'Geen afbeelding',
    properties: 'Eigenschappen',
    category: 'Categorie',
    value: 'Ter waarde van',
    dimensions: 'Afmetingen',
    weight: 'Gewicht',
    location: 'Locatie',
    condition: 'Materiaal conditie',
    status: 'Status materiaal',
    provider: 'Aanbieder',
    claimCta: 'Ik wil dit claimen',
    claimError: 'Claimen mislukt. Probeer het later opnieuw.',
    deliverError: 'Levering aanbieden mislukt. Probeer het later opnieuw.',
    claimSuccessBody: 'Dit materiaal is nu van jou! Hoe nu verder?',
    claimSuccessStep1: 'De aanbieder neemt contact met je op voor het maken van een afspraak om de materialen op te halen.',
    claimSuccessStep2: 'In jouw account zie je jouw claims met daarbij het claimformulier.',
    readMore: 'Lees meer',
    readLess: 'Minder',
    valueInfoTitle: 'Waarde toelichting',
    valueInfoBody: 'De materialen worden GRATIS aangeboden. We vermelden alleen dit bedrag om aan te geven voor welke waarde het vertegenwoordigt en voor het indienen van cofinanciering.',
    providerType: 'Type aanbieder',
    fromSchool: 'School',
    fromCompany: 'Bedrijf',
    type: 'Type',
    offered: 'Aangeboden',
    requested: 'Gevraagd',
    deliverCta: 'Ik wil dit leveren',
    deliverSuccessBody: 'Jouw aanbod om te leveren is verzonden! Hoe nu verder?',
    deliverSuccessStep1: 'De vragende partij neemt contact met je op om de verdere afhandeling te bespreken.',
    deliverSuccessStep2: 'In jouw account zie je jouw leveringen met daarbij het leveringsformulier.',
    todoBedrijf: 'Claims op jouw materialen',
    todoSchool: 'Lopende claims',
  },
  newsletter: {
    settingsTitle: 'Nieuwsbrief instellingen',
    settingsDesc: 'Ontvang periodiek een e-mail met de nieuwste aangeboden en gevraagde materialen.',
    frequencyLabel: 'Frequentie',
    frequencyOff: 'Uitgeschakeld',
    frequencyWeekly: 'Wekelijks',
    frequencyBiweekly: 'Tweewekelijks (standaard)',
    frequencyMonthly: 'Maandelijks',
  },
  consent: {
    html: 'Ik geef toestemming om mijn gegevens te gebruiken voor het aanmaken van een account en ik ga akkoord met het <a href="https://materiaalmaatjes.bonsaidev.nl/privacybeleid/" target="_blank" class="underline">privacybeleid</a> en de <a href="https://materiaalmaatjes.bonsaidev.nl/algemene-voorwaarden/" target="_blank" class="underline">algemene voorwaarden</a> van Materiaal Maatjes. Daarnaast verklaar ik dat mijn organisatie instemt met de registratie en administratieve verwerking van het aanbieden of ontvangen van restmaterialen binnen dit platform en dat hiervoor geen aanvullende schriftelijke ondertekening vereist is. *'
  },
  validation: {
    step1Invalid: 'Vul een geldige postcode in (stap 1).',
    nameMissing: 'Vul je voor- en achternaam in.',
    emailMissing: 'Vul je e-mailadres in en bevestig deze.',
    emailInvalid: 'Vul een geldig e-mailadres in.',
    emailsNoMatch: 'De e-mailadressen komen niet overeen.',
    orgMissing: 'Vul je organisatie en functie in.',
    addressMissing: 'Vul het volledige adres in.',
    websiteMissing: 'Vul het website adres in.',
    phoneMissing: 'Vul het telefoonnummer in.',
    consentMissing: 'Geef toestemming voor verwerking van je gegevens.',
    robotCheckMissing: 'Bevestig dat je geen robot bent.',
    requiredField: 'Dit is verplicht.',
    chooseOption: 'Kies een optie.',
  },
}